import apiClient from '../utils/apiClient';

const creditNoteService = {
  getCreditNotes: async (filters = {}, page = 1, limit = 10) => {
    try {
      const queryParams = new URLSearchParams();
      
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });
      
      const response = await apiClient.get(`/creditNotes?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching credit notes:', error);
      throw error.response?.data || { message: 'Error fetching credit notes' };
    }
  },

  getCreditNoteByInvoiceNo: async (invoiceNo) => {
    try {
      const response = await apiClient.get(`/creditNotes/${invoiceNo}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching credit note ${invoiceNo}:`, error);
      throw error.response?.data || { message: 'Error fetching credit note' };
    }
  },

  getNextCreditNoteNumber: async () => {
    try {
      const response = await apiClient.get('/creditNotes/next-invoice-number');
      return response.data;
    } catch (error) {
      console.error('Error fetching next credit note number:', error);
      throw error.response?.data || { message: 'Error fetching next credit note number' };
    }
  },
  
  createCreditNote: async (creditNoteData) => {
    try {
      const response = await apiClient.post('/creditNotes', creditNoteData);
      return response.data;
    } catch (error) {
      console.error('Error creating credit note:', error);
      throw error.response?.data || { message: 'Error creating credit note' };
    }
  },
  
  updateCreditNote: async (invoiceNo, creditNoteData) => {
    try {
      const response = await apiClient.put(`/creditNotes/${invoiceNo}`, creditNoteData);
      return response.data;
    } catch (error) {
      console.error(`Error updating credit note ${invoiceNo}:`, error);
      throw error.response?.data || { message: 'Error updating credit note' };
    }
  },
  
  deleteCreditNote: async (invoiceNo) => {
    try {
      const response = await apiClient.delete(`/creditNotes/${invoiceNo}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting credit note ${invoiceNo}:`, error);
      throw error.response?.data || { message: 'Error deleting credit note' };
    }
  }
};

export default creditNoteService;
